import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { MaterialLoader } from 'components/loaders'
import styles from './elevated-button.styl'

export default class ElevatedButton extends Component {
  static propTypes = {
    children: PropTypes.any,
    extraWide: PropTypes.bool,
    fullWidth: PropTypes.bool,
    isLoading: PropTypes.bool,
    secondary: PropTypes.bool,
    uppercase: PropTypes.bool,
    addIcon: PropTypes.bool,
    rounded: PropTypes.bool,
    warning: PropTypes.bool,
    medium: PropTypes.bool,
    padded: PropTypes.bool,
    submit: PropTypes.bool,
    large: PropTypes.bool,
    oval: PropTypes.bool,
    high: PropTypes.bool,
    disabled: PropTypes.bool,
    flat: PropTypes.bool,
    negative: PropTypes.bool,
    inline: PropTypes.bool,
    onClick: PropTypes.func,
    link: PropTypes.bool,
    intlKey: PropTypes.string,
    colorClass: PropTypes.string,
    small: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    extraWide: false,
    fullWidth: false,
    isLoading: false,
    uppercase: false,
    addIcon: false,
    warning: false,
    rounded: false,
    medium: false,
    padded: false,
    large: false,
    oval: false,
    high: false,
    submit: false
  }

  render() {
    const {
      extraWide,
      fullWidth,
      isLoading,
      uppercase,
      addIcon,
      warning,
      rounded,
      intlKey,
      padded,
      medium,
      submit,
      large,
      oval,
      high,
      onClick,
      children,
      colorClass,
      disabled,
      flat,
      small,
      negative,
      inline,
      className,
      link,
      secondary
    } = this.props
    const classNames = [styles.wrap, className]

    extraWide && classNames.push(styles.extraWide)
    fullWidth && classNames.push(styles.fullWidth)
    isLoading && classNames.push(styles.isLoading)
    uppercase && classNames.push(styles.uppercase)
    addIcon && classNames.push(styles.addIcon)
    warning && classNames.push(styles.warning)
    small && classNames.push(styles.small)
    rounded && classNames.push(styles.rounded)
    padded && classNames.push(styles.padded)
    medium && classNames.push(styles.medium)
    large && classNames.push(styles.large)
    oval && classNames.push(styles.oval)
    high && classNames.push(styles.high)
    colorClass && classNames.push(styles[colorClass])
    disabled && classNames.push(styles.disabled)
    flat && classNames.push(styles.flat)
    negative && classNames.push(styles.negative)
    inline && classNames.push(styles.inline)
    secondary && classNames.push(styles.secondary)
    link && classNames.push(styles.link)

    return (
      <button
        className={classNames.join(' ')}
        onClick={onClick}
        type={submit ? 'submit' : 'button'}
        disabled={isLoading || disabled}
      >
        {isLoading &&
          <div className={styles.loader}>
            <MaterialLoader white={!secondary} small />
          </div>}
        {addIcon && <i className={`ico ico--add ${styles.add}`} />}
        {intlKey
          ? <FormattedMessage
              id={intlKey}
              defaultMessage={typeof children === 'string' ? children : ''}
          />
          : children}
      </button>
    )
  }
}
